import clsx from "clsx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { FEEDBACK_RATING } from "../ai-curriculum.constants";

import "./ai-recommendation-feedback.scss";

// "Do you like these results?" thumbs up/down control (ENG-23158). Clicking a
// thumb sets that rating; clicking the already-active thumb clears it (null).
// The control is optional and non-blocking — the parent persists the choice
// and swallows failures.
export const AiRecommendationFeedback = ({ rating, onChange }) => {
  const select = (value) => onChange(rating === value ? null : value);

  const thumb = (value, icon, label) => {
    const selected = rating === value;
    return (
      <button
        type="button"
        className={clsx(
          "ai-recommendation-feedback__thumb",
          selected && "ai-recommendation-feedback__thumb--selected"
        )}
        aria-label={label}
        aria-pressed={selected}
        onClick={() => select(value)}
      >
        <FontAwesomeIcon icon={[selected ? "fa-solid" : "fa-regular", icon]} />
      </button>
    );
  };

  return (
    <div className="ai-recommendation-feedback">
      <span className="ai-recommendation-feedback__prompt">
        Do you like these results?
      </span>
      {thumb(FEEDBACK_RATING.UP, "thumbs-up", "Thumbs up")}
      {thumb(FEEDBACK_RATING.DOWN, "thumbs-down", "Thumbs down")}
    </div>
  );
};
